import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
  Radio,
  Modal
} from "antd";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import R2Footer from "../../../components/Footer";
import ItemList from "./childrens/itemList";
import Availability from "./childrens/availability";
import "./styles.scss";

const { Content } = Layout;

const Ingredients = (props) => {
  const [ showCourse, setShowCourse]= useState('item');
  const [ expandId, setExpandId]= useState('all');

  return (
    <Layout className="u-page-layout">
      <Content>
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
        <div className="head_section">
            <PageHeader className="page-header" title={showCourse === "ingredients" ? "Ingredient Availability" : "Item Inventory"} style={{ background: "#f0f2f5" }} />
            <div>
              <Radio.Group
                size="large"
                value={showCourse}
                onChange={(e) => setShowCourse(e.target.value)}
              >
                <Radio.Button value="item">Item</Radio.Button>
                <Radio.Button value="ingredients">Ingredients</Radio.Button>
              </Radio.Group>
            </div>
        </div>
            {showCourse === 'item' ?
              <ItemList
                {...props}
                expandId={expandId}
                setExpandId = {setExpandId}
              />
              :
              <Availability {...props} />}
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};
const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(Ingredients));
